import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { Product } from "@medical-association/shared";
import { useState } from "react";

const ProductManagement = () => {
	const [products, setProducts] = useState<Product[]>([]);
	const [isAddingNew, setIsAddingNew] = useState(false);

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h2 className="text-2xl font-semibold">Product Management</h2>
				<Button onClick={() => setIsAddingNew(true)}>Add New Product</Button>
			</div>

			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>Name</TableHead>
						<TableHead>Code</TableHead>
						<TableHead>Status</TableHead>
						<TableHead>Company</TableHead>
						<TableHead>Added Date</TableHead>
						<TableHead>Actions</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{products.map((product) => (
						<TableRow key={product.id}>
							<TableCell>{product.name}</TableCell>
							<TableCell>{product.code}</TableCell>
							<TableCell>{product.status}</TableCell>
							<TableCell>{product.manufacturer}</TableCell>
							<TableCell>{product.dateAdded}</TableCell>
							<TableCell>
								<Button variant="outline" size="sm">
									Edit
								</Button>
								<Button variant="destructive" size="sm">
									Delete
								</Button>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default ProductManagement;
